import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './household-size.reducer';

export const HouseholdSizeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const householdSizeEntity = useAppSelector(state => state.householdSize.entity);
  const loading = useAppSelector(state => state.householdSize.loading);
  const updating = useAppSelector(state => state.householdSize.updating);
  const updateSuccess = useAppSelector(state => state.householdSize.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/household-size${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.onePerson !== undefined && typeof values.onePerson !== 'number') {
      values.onePerson = Number(values.onePerson);
    }
    if (values.twoPeople !== undefined && typeof values.twoPeople !== 'number') {
      values.twoPeople = Number(values.twoPeople);
    }
    if (values.threePeople !== undefined && typeof values.threePeople !== 'number') {
      values.threePeople = Number(values.threePeople);
    }
    if (values.fourPeople !== undefined && typeof values.fourPeople !== 'number') {
      values.fourPeople = Number(values.fourPeople);
    }
    if (values.fivePeople !== undefined && typeof values.fivePeople !== 'number') {
      values.fivePeople = Number(values.fivePeople);
    }
    if (values.sixPeople !== undefined && typeof values.sixPeople !== 'number') {
      values.sixPeople = Number(values.sixPeople);
    }
    if (values.sevenPeople !== undefined && typeof values.sevenPeople !== 'number') {
      values.sevenPeople = Number(values.sevenPeople);
    }
    if (values.eightOrMorePeople !== undefined && typeof values.eightOrMorePeople !== 'number') {
      values.eightOrMorePeople = Number(values.eightOrMorePeople);
    }

    const entity = {
      ...householdSizeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...householdSizeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.householdSize.home.createOrEditLabel" data-cy="HouseholdSizeCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.householdSize.home.createOrEditLabel">Create or edit a HouseholdSize</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="household-size-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.householdSize.geographicLevel')}
                id="household-size-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.householdSize.date')}
                id="household-size-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.geography')}
                id="household-size-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.geographyCode')}
                id="household-size-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.totalAllHouseholds')}
                id="household-size-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.onePerson')}
                id="household-size-onePerson"
                name="onePerson"
                data-cy="onePerson"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.twoPeople')}
                id="household-size-twoPeople"
                name="twoPeople"
                data-cy="twoPeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.threePeople')}
                id="household-size-threePeople"
                name="threePeople"
                data-cy="threePeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.fourPeople')}
                id="household-size-fourPeople"
                name="fourPeople"
                data-cy="fourPeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.fivePeople')}
                id="household-size-fivePeople"
                name="fivePeople"
                data-cy="fivePeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.sixPeople')}
                id="household-size-sixPeople"
                name="sixPeople"
                data-cy="sixPeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.sevenPeople')}
                id="household-size-sevenPeople"
                name="sevenPeople"
                data-cy="sevenPeople"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdSize.eightOrMorePeople')}
                id="household-size-eightOrMorePeople"
                name="eightOrMorePeople"
                data-cy="eightOrMorePeople"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/household-size" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HouseholdSizeUpdate;
